import React from "react";
import { Button, Typography, Box } from "@mui/material";
import { FiMail } from "react-icons/fi";

const ProductHelpButton = ({ handleOpenQueryModal }) => {
    return (
        <Box sx={{
display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom:"10px",
        }}>
        <FiMail size={18} />
        <Typography
            sx={{
                color: "#211715",
                fontSize: "15px",
                fontWeight: 500,
            }}
        >
            Can’t find your product? 
        </Typography>
        <Button
            // variant="contained"
            onClick={handleOpenQueryModal}
            sx={{
                color: "#2563EB",
                textTransform: "none",
                fontSize: "15px",
                fontWeight: 700,
                borderBottom: "1px solid #2563EB",
                padding:0,
                borderRadius:0,
                "&:hover": {
                    borderColor:  "#211715",
                },
            }}
        >
             Contact us
            {/* Request Product Assistance */}
        </Button>
        </Box>
    );
};

export default ProductHelpButton;
